import { useContext, useEffect, useState } from 'react';
import AppContext from '../AppContext';

import { formatMoney } from '../utils/money';
import { usePrevious } from '../utils/hooks';
import { isDeepEqual } from '../utils/objects';

import { getTotalPrice } from '../selectors';

const CalculateOrderData = ({
  order,
  previousOrder,
  setInitialLoading,
  setOrderData,
  context,
  shouldRender,
  orderData,
}) => {
  useEffect(() => {
    if (
      isDeepEqual(
        order.doc.products,
        previousOrder ? previousOrder.doc.products : {},
      )
    ) return;
    setInitialLoading(true);
    if (!order || order === {}) return;
    setOrderData(getTotalPrice(context, order));
    setInitialLoading(false);
  }, [
    context,
    order,
    previousOrder,
    shouldRender,
    orderData,
    setOrderData,
    setInitialLoading,
  ]);
};

export const OrderTotalEffect = ({ shouldRender, order }) => {
  const [orderData, setOrderData] = useState({});
  const context = useContext(AppContext);
  const previousOrder = usePrevious(order);
  const [initialLoading, setInitialLoading] = useState(false);

  CalculateOrderData({
    order,
    previousOrder,
    setInitialLoading,
    setOrderData,
    context,
    shouldRender,
    orderData,
  });

  const discount = order.doc.discount / 100;
  const appliedDiscount = discount * orderData.total || 0;

  return {
    appliedDiscount,
    initialLoading,
    orderData,
    totalAfterDiscounts: formatMoney(
      orderData.total - appliedDiscount,
      orderData.currency,
    ),
  };
};

export default OrderTotalEffect;
